
import { mixins } from 'vue-class-component'
import { Component, Prop } from 'vue-property-decorator'
import { AppSwitch, AppInput } from '@/components'
import { ChildComponentMixin } from '@/mixins'
import { appEntity } from '@/models/models'
import { READY_FOR_SALE } from '@/utils/statusApp'
import DetailAndroidAccountForm from '@/components/DetailAndroidAccountForm.vue'

@Component({
    components: {
        AppInput,
        AppSwitch,
        DetailAndroidAccountForm,
    },
})
export default class DetailAndroid extends mixins(ChildComponentMixin) {
    @Prop() public value?: AppEntity

    get app(): AppEntity {
        return this.value ?? appEntity
    }

    get showAppUrl(): boolean {
        if (this.app.android) {
            const index = this.app.android.updates.findIndex((u) => u.status === READY_FOR_SALE)
            if (index !== -1) {
                return true
            }
        }

        return false
    }

    public goToPlayStore(e: Event) {
        if (this.app.android) {
            window.open(this.app.android!.url, '_blank')
        }
    }
}
